import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { clsx } from 'clsx';

const cardStyles = cva('rounded-lg border border-border', {
  variants: {
    variant: {
      default: 'bg-surface',
      subtle: 'bg-subtle',
    },
    padding: {
      none: 'p-0',
      sm: 'p-3',
      md: 'p-5',
      lg: 'p-7',
    },
  },
  defaultVariants: {
    variant: 'default',
    padding: 'md',
  },
});

interface CardProps extends HTMLAttributes<HTMLElement>, VariantProps<typeof cardStyles> {}

export const Card = forwardRef<HTMLElement, CardProps>(function Card(
  { variant, padding, className, ...rest },
  ref
) {
  return (
    <section ref={ref} className={clsx(cardStyles({ variant, padding }), className)} {...rest} />
  );
});
